import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import VueAwesomeSwiper from 'vue-awesome-swiper'
const app = createApp(App)
app.config.globalProperties.$url = "http://122.9.113.133:8070";
if(window.sessionStorage.getItem("language") as string){
    app.config.globalProperties.$language =window.sessionStorage.getItem("language") as string  ;
}else{
    app.config.globalProperties.$language = "CN";
}

app.use(store).use(router,axios,VueAwesomeSwiper).mount('#app')
